'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';

export default function HtmlLang() {
  const searchParams = useSearchParams();
  const localeParam = searchParams?.get('locale');
  const localeLanguage = searchParams?.get('locale_language');

  const languageParam = localeParam ? localeParam.split(/[_-]/, 2)[0] : '';

  useEffect(() => {
    document.documentElement.lang = localeLanguage || languageParam || 'en';
  }, [localeParam, localeLanguage]);

  return null;
}
